import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import ModalManager from '@components/Evaluator/ModalManager';

import { getListGestors, addGestor, updateGestor } from '@actions/evaluators';
import { sendActionToBitacora  } from '@actions/bitacora';

import { StatusConst } from '@constants/general';


class AssociateManagers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      btnSubmitLoading: false,
      associates: [],
      showModalManager: {
        isVisible: false,
        title: '',
        nombre: '',
        estatus: '',
        correo: '',
        label: '',
        isEdit: false,
        continueAction: null
      }
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const { getListGestors, _evaluatorId } = this.props;
    this.setState({ loadingTable: true });
    const response = await getListGestors(_evaluatorId);
    // let response = {}
    // response.data = [{"correo":"coordinador-itt1@correo.com","nombre":"Coordinador Intertek 1","estatus":1},{"correo":"coordinador-itt2@correo.com","nombre":"Coordinador Intertek 2","estatus":1},{"correo":"coordinador-itt3@correo.com","nombre":"Coordinador Intertek 3","estatus":0}]
    if (!response?.status) {
      return this.setState({
        associates: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };


  onAddMManagerModal = () => {
    const { t } = this.props
    this.setState({
      showModalManager: {
        isVisible: true,
        value: '',
        title: t('Agregar gestor'),
        btnOkLabel: t('Agregar'),
        isEdit: false,
        continueAction: (data, justification) => this.addManager(data, justification),
      },
    });
  }

  addManager = async (data, justification) => {
    const { addGestor, _evaluatorId, sendActionToBitacora } = this.props
    const response = await addGestor({nombre: data.nombre, correo: data.correo, id_evaluador: _evaluatorId})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'altaGestor',
        reason: `${data.correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData();
    }
    return this.setState({ btnSubmitLoading: false });
  }

  onEditMAnagerModal = (detail) => {
    const { t } = this.props
    this.setState({
      showModalManager: {
        isVisible: true,
        nombre: detail.nombre,
        estatus: detail.estatus,
        title: t('Datos del Gestor'),
        btnOkLabel: t('Guardar'),
        isEdit: true,
        continueAction: (data, justification) => this.editManager(data, detail.correo, justification),
      },
    });
  }

  editManager = async (data, correo, justification) => {
    const { updateGestor, sendActionToBitacora } = this.props
    const response = await updateGestor({nombre: data.nombre, estatus: data.estatus, correo})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actGestor',
        reason: `${correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData();
    }
    return this.setState({ btnSubmitLoading: false });
  }

  onHideModalContact = () => {
    this.setState({
      showModalManager: {
        isVisible: false,
      },
    });
  };

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  templateEdit = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onEditMAnagerModal(node)}
      />
    </div>
  );

  templateStatus = (node, detail) => {
    const { t } = this.props
    if (node.estatus === StatusConst.IS_ACTIVE) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check p-mr-2"></i>
        </div>
      )
    } else if (node.estatus === StatusConst.IS_SUSPENDED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red"> {t('SUSPENDIDO')} </span>
        </>
      )
    }
  }

  render() {
    const { t } = this.props;
    const { loadingTable, btnSubmitLoading, associates, showModalManager } = this.state;

    return (
      <>
        <div className="p-col-12 p-mt-2">
          <DataTable
            value={associates}
            lazy
            className="table-languages"
            emptyMessage={t("No existen datos de gestores asociados")}
            loading={loadingTable}
            stripedRows
          >
            <Column
              header={t('Nombre')}
              field="nombre"
              body={this.columnResponsive}
            />
            <Column
              header={t('Correo electrónico')}
              field="correo"
              body={this.columnResponsive}
              // className="column-action p-mr-4"
            />
            <Column
              header={t('Estatus')}
              field="estatus"
              body={this.templateStatus}
              className="p-text-center-lg"
            />
            <Column
              header={t('Editar')}
              body={this.templateEdit}
              className="column-action p-text-center-lg"
            />
          </DataTable>
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-end">
            <Button
              label={t('Agregar gestor')}
              type="button"
              className="p-button-primary"
              onClick={this.onAddMManagerModal}
              loading={btnSubmitLoading}
            />
          </div>
          { showModalManager.isVisible && (
            <ModalManager
              display={showModalManager.isVisible}
              title={showModalManager.title}
              nombre={showModalManager.nombre}
              isEdit={showModalManager.isEdit}
              correo={showModalManager.correo}
              estatus={showModalManager.estatus}
              btnOkLabel={showModalManager.btnOkLabel}
              label={showModalManager.label}
              onHidden={() => this.onHideModalContact()}
              onContinueAction={showModalManager.continueAction}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _evaluatorId: state.evaluator.id
});

const mapDispatchToProps = {
  getListGestors,
  addGestor,
  updateGestor,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(AssociateManagers);
